import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 48px;
    height: 48px;
`;

export const LiquidIdStyled = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 86px;
    aspect-ratio: 1;
    cursor: pointer;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: 12px;
        left: 12px;
    }
`;
